import { RedirectPage } from "components/UI/RedirectPage/RedirectPage";
import { Route as IncomingPostbackLogPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback";
import { Route as IncomingPostbackStepLogPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps";
import { Route as TrackingToLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/to";
import { Route as OutgoingPostbackLogPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api";
import { Route as OutgoingPostbackStepLogPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api-steps";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/tracking/")({
    component: TrackingLogsPage,
    staticData: {
        permissions: [
            PermissionEnum.IncomingPostbackLogView,
            PermissionEnum.StepLogIncomingPostbacksView,
            PermissionEnum.OutgoingPostbackLogView,
            PermissionEnum.OutgoingPostbackView,
            PermissionEnum.StepLogOutgoingPostbacksView,
        ],
        showInSideMenu: false,
        label: "pages.log.tracking.title",
        redirects: [
            IncomingPostbackLogPage,
            IncomingPostbackStepLogPage,
            TrackingToLogsPage,
            OutgoingPostbackLogPage,
            OutgoingPostbackStepLogPage,
        ],
        defaultRedirect: IncomingPostbackLogPage,
    },
});
function TrackingLogsPage() {
    return <RedirectPage />;
}
